// removed by extract-text-webpack-plugin
module.exports = {"raisedText":"RaisedText-module__raisedText___2B6c5","raisedText__content":"RaisedText-module__raisedText__content___MCYI4","collapse__handle":"RaisedText-module__collapse__handle___G1P7l","raisedText__label":"RaisedText-module__raisedText__label___1MJhe","iconRight":"RaisedText-module__iconRight___ptHfJ","collapseContainer":"RaisedText-module__collapseContainer___2mx3d","collapse__content":"RaisedText-module__collapse__content___2c6x7","isCollapsed":"RaisedText-module__isCollapsed___3g85N","isTransform":"RaisedText-module__isTransform___WZd8O"};


//////////////////
// WEBPACK FOOTER
// ./src/app/components/UI/RaisedText/RaisedText.module.css
// module id = 262
// module chunks = 0